import { Menu, MenuCategory, MenuItem } from "@/types/menu";
import { SupabaseClient } from "@supabase/supabase-js";
import { Database } from "@/lib/supabase/client";

export type MenuLanguage = keyof typeof TAX_INCLUDED_TEXT;

export const TAX_INCLUDED_TEXT = {
  japanese: "税込",
  english: "Tax included",
  "chinese-simplified": "含税",
  "chinese-traditional": "含稅",
  korean: "세금 포함",
  thai: "รวมภาษี",
  vietnamese: "Đã bao gồm thuế",
  french: "TTC",
  german: "Inkl. MwSt.",
  italian: "IVA inclusa",
  russian: "С учетом налога",
  spanish: "Impuestos incluidos",
  bhojpuri: "टैक्स शामिल",
  arabic: "شامل الضريبة",
  persian: "شامل مالیات",
  turkish: "Vergi dahil",
  czech: "Včetně daně",
  dutch: "Inclusief belasting",
  indonesian: "Termasuk pajak",
  malay: "Termasuk cukai",
  filipino: "Kasamang buwis",
  polish: "Z podatkiem",
  portuguese: "Impostos incluídos",
  "portuguese-brazilian": "Impostos incluídos",
  romanian: "Taxe incluse",
  slovenian: "Vključen davek",
  swedish: "Inkl. moms",
  cantonese: "包稅",
  hindi: "कर सहित",
} as const;

export interface MenuItemCardProps {
  item: MenuItem;
  language: string;
  categoryId: string;
  menuId?: string;
  onUpdate?: (updatedItem: MenuItem) => void;
  isEditable?: boolean;
  supportedLanguages?: string[];
  menu: Menu;
}

export interface CategorySectionProps {
  category: MenuCategory;
  language: string;
  id: string;
  onUpdate?: (updatedCategory: MenuCategory) => void;
  onDelete?: (category: MenuCategory) => void;
  items: MenuItem[];
  isDropTarget?: boolean;
  activeId?: string;
  overId?: string;
  isEditable?: boolean;
  menu: Menu;
  menuId: string;
}

export interface CategoryNavProps {
  menu: Menu;
  language: string;
  activeCategory: string;
  onCategoryClick: (id: string) => void;
  onAddCategory: () => void;
  variant?: "default" | "sheet";
  isEditable?: boolean;
  isRTL?: boolean;
}

export interface MenuBannerProps {
  url?: string;
  isExpanded: boolean;
  onToggle: () => void;
  onUpload?: (file: File) => Promise<void>;
  onRemove?: () => Promise<void>;
  isEditable?: boolean;
}

export interface StructuredMenuProps {
  menu: Menu;
  menuId: string;
  language?: string;
  languageControls?: React.ReactNode;
  customControls?: React.ReactNode;
  isEditable?: boolean;
  onBannerUpload?: (file: File) => Promise<void>;
  uiLabels?: {
    categories: string;
    items: string;
    viewMedia?: string;
    sendFeedback?: string;
  };
  onBannerClick?: (index: number) => void;
  supabase?: SupabaseClient<Database>;
} 